<template>
    <div class="container-xxl py-5">
      <div class="container">
        <div class="text-center">
          <h6 class="section-title text-center text-primary text-uppercase">Üyelik Avantajları</h6>
          <h1 class="mb-5">Hemşehrilerimize <span class="text-primary text-uppercase">Özel</span></h1>
        </div>
  
        <div class="row g-4">
          <div
            v-for="(service, index) in SERVICES"
            :key="index"
            class="col-lg-4 col-md-6"
            :data-wow-delay="`${(index % 3 + 1) * 0.1}s`"
          >
            <a class="service-item rounded" :href="whatsappUrl(service.title)" target="_blank" rel="noopener">
              <div class="service-icon bg-transparent border rounded p-1">
                <div class="w-100 h-100 border rounded d-flex align-items-center justify-content-center">
                  <i :class="`fa ${service.icon} fa-2x text-primary`"></i>
                </div>
              </div>
              <h5 class="mb-3">{{ service.title }}</h5>
              <p class="text-body mb-0">{{ service.description }}</p>
            </a>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script setup>
  import SERVICES from '@/data/services';

  const whatsappUrl = (serviceTitle) => {
    const message = `Derneğinize websitesinden katıldım, ${serviceTitle} hizmeti hakkında bilgi almak istiyorum.`
    return `https://wa.me/905079217404?text=${encodeURIComponent(message)}`
  }
  </script>
  
